import script from "./ProjectListEmptyState.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectListEmptyState.vue?vue&type=script&lang=ts&setup=true"

import "./ProjectListEmptyState.vue?vue&type=style&index=0&id=426a990e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-426a990e"]])

export default __exports__